import React, { useState } from 'react'
import styled from 'styled-components'
import { Row, Col, Button, Form } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import kv from '../../images/backdrops/kv.png'
import title from '../../images/backdrops/title.png'
import brand from '../../images/backdrops/entrance-brand.png'
import brandOrganiser from '../../images/backdrops/organiser.png'
import brandSponsor from '../../images/backdrops/sponsor.png'
import { COLORS, SIZES } from '../../styles/theme'
import Axios from 'axios'
import config from '../../config'
import { toast } from 'react-toastify'
import routes from '../../routes'

const Page = styled.div`
  min-height: 100vh;
  background-image: url(${config.assets.register.landscape});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding: 0;
  padding-bottom: 2em;
  padding-top: 2em;
  color: #000000;
  text-align: center;

  .mobile-show {
    display: none;
  }
  .brand {
    width: 100%;
    margin: 0 auto;
    height: 100%;
    padding-bottom: 3em;
    align-items: center;
    ${SIZES.mobile} {
      height: inherit;
      padding-bottom: 1em;
    }
  }

  .row {
    select.form-input {
      text-align-last: center;
    }

    h6.subtitle {
      font-weight: 500;
      margin: 24px 0;
    }
    .error-message {
      font-weight: 500;
      color: #C10244;
    }

    .register-form {
      padding: 2.5em 0;

      .form-group {
        width: 100%;
        margin: 8px auto;
        background: #F3F3F3;
        border: 1px solid rgba(139, 94, 192, 0.4);
        border-radius: 8px;
        font-weight: 400;
        text-align: center;
        padding-right: 16px;
        font-size: 13px;
        label {
          color: #000000;
          padding: 0 8px;
          margin: 0 auto;
          padding-right: 0;
          font-size: 16px;
        }
        .required:before {
          content:"* ";
          color: red;
        }
        input[type='tel'],
        .form-input {
          display: block;
          color: #8D8D8D;
          width: 100%;
          background: transparent;
          border: none;
          padding: 16px 24px;
          outline: none;
          text-align: center;
        }
      }
      #password {
        width: 12px;
        margin: 2px 4px;
      }
    }
  }
  ${SIZES.mobile} {
    background-image: url(${config.assets.register.portrait});
    padding: 0;
    padding-bottom: 2.5em;
    padding-top: 1em;
    font-size: 0.9em;
    .mobile-show {
      display: block;
    }
    .mobile-hide {
      display: none;
    }
    .col-md-6 {
      flex: none;
      max-width: 100%
    }
    .subtitle, .error-message {
      padding: 0 20px;
      font-size: 12px;
      font-weight: 600;
    }
  }

  button.submit-btn {
    background: #10227A;
    width: 40%;
    color: #FFA600;
    font-weight: 400;
    border: none;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    padding: 8px 24px;
    margin: 16px auto;
    margin-bottom: 0;
    font-size: 1em;
    outline: none;

    ${SIZES.mobile} {
      width: 100%;
      padding: 10px 24px;
    }

    &:disabled {
      cursor: not-allowed;
      background: grey;
      color: white;
      border: solid 1px ${COLORS.primary};
    }

    div {
      line-height: 32px;
    }
  }
  .form-check {
    display: flex;
    text-align: left;
    #agree-box {
      margin-top: 8px;
      padding: 8px;
    }
    .form-check-label {
      font-weight: 400;
      font-size: 10px;
      margin-left: 8px;
      color: #000000;
      a {
        color: red;
        text-decoration: underline;
      }
    }
  }
`

export default function RegisterFormPage() {
  const history = useHistory()
  const [loading, setLoading] = useState(false)

  const [salutation, setSalutation] = useState('')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [institution, setInstitution] = useState('')
  const [password, setPassword] = useState('')
  const [agreeFirst, setAgreeFirst] = useState(false)
  const [agreeSecond, setAgreeSecond] = useState(false)

  const handleCheckBox = (e) => {
    setAgreeFirst(e.target.checked)
  }

  const handleEmailInput = (e) => {
    setEmail(e.target.value.toLowerCase())
  }
  
  const handleSubmit = (e) => {
    e.preventDefault()
    setLoading(true)
    
    const options = {
      salutation: salutation.trim(),
      first_name: firstName.trim(),
      last_name: lastName.trim(),
      email,
      institution: institution.trim(),
      password: password.trim(),
    }
    Axios.post(`${config.apiUrl}/api/register`, options)
      .then(() => {
        setLoading(false)
        history.push(routes.postRegister)
      })
      .catch((err) => {
        setLoading(false)
        toast(err.response.data.message)
      })
  }

  const hasEmptyField = !(
    salutation.length &&
    firstName.length &&
    lastName.length &&
    institution.length &&
    email.length &&
    agreeFirst &&
    agreeSecond &&
    password.length >= 6
  )

  return (
    <Page>
      <Row id="main" noGutters className="px-4 pt-2 pb-3">

        <Col md={6}>
          <div className="mobile-show">
            <img width="90%" src={title} alt="event-title" className="d-block mx-auto" />
          </div>
          <Row noGutters className="brand px-md-4">
            <Col sm={6} lg={12}>
              <img width="90%" src={kv} alt="event-banner" className="d-block mx-auto" />
            </Col>
            <Col sm={6} lg={12}>
              <div className="mobile-hide">
                <img width="90%" src={brand} alt="event-logo" className="d-block mx-auto" />
              </div>
              <div className="mobile-show mt-3">
                <img width="90%" src={brandOrganiser} alt="event-logo" className="d-block mx-auto" />
                <img width="90%" src={brandSponsor} alt="event-logo" className="d-block mx-auto" />
              </div>
            </Col>
          </Row>
        </Col>

        <Col md={6} className="px-md-4">
          <div className="mobile-hide">
            <img width="80%" src={title} alt="event-title" className="d-block mx-auto" />
          </div>

          {hasEmptyField && (
            <p className="error-message m-0">
              * Please fill in the required field to proceed.
            </p>
          )}
          
          <Row className="register-form py-3" noGutters>
            <Col md={12} className="px-md-2">
              <Form.Group>
                <input
                  className="form-input"
                  required
                  type="text"
                  value={salutation}
                  placeholder="* Salutation"
                  onChange={(e) => setSalutation(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={12} className="px-md-2">
              <Form.Group>
                <input
                  className="form-input"
                  required
                  type="text"
                  value={firstName}
                  placeholder="* First Name"
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={12} className="px-md-2">
              <Form.Group>
                <input
                  className="form-input"
                  required
                  type="text"
                  value={lastName}
                  placeholder="* Last Name"
                  onChange={(e) => setLastName(e.target.value)}
                />
              </Form.Group>
            </Col>
            
            
            <Col md={12} className="px-md-2">
              <Form.Group>
                <input
                  className="form-input"
                  required
                  type="text"
                  value={institution}
                  placeholder="* Institution / Company"
                  onChange={(e) => setInstitution(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={12} className="px-md-2">
              <Form.Group>
                <input
                  className="form-input"
                  required
                  type="email"
                  value={email}
                  placeholder="* Email"
                  onChange={handleEmailInput}
                />
              </Form.Group>
            </Col>

            <Col md={12} className="px-md-2">
              <Form.Group>
                <input
                  className="form-input"
                  required
                  type="password"
                  value={password}
                  placeholder="* Event Password (Min. 6 characters)"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Group>
            </Col>

            <div className="form-check px-3 px-md-0">
              <input 
                type="checkbox" 
                id="agree-box" 
                onChange={handleCheckBox}
                />
              <label className="form-check-label">
                <span className="text-danger">*</span>
                  &nbsp;I acknowledge that I have read and understood this Notice and the purposes for which UTP will process my&nbsp;
                  <a href="https://drive.google.com/file/d/1MLZeSDZR44UohC-2Bj0WaN9C1NYGDNmS/view?usp=sharing" target="_blank" rel="noopener noreferrer">
                    Personal Data
                  </a>
                  &nbsp;(including Sensitive Personal Data). I expressly consent to UTP processing my Personal Data (including my Sensitive Personal Data) in accordance with this Notice.
              </label>
            </div>
            
            <div className="form-check px-3 px-md-0 mt-3">
              <input 
                type="checkbox" 
                id="agree-box" 
                onChange={(e)=>setAgreeSecond(e.target.checked)}
                />
              <label className="form-check-label">
                <span className="text-danger">*</span>
                  &nbsp;I consent to UTP processing my Personal Data for direct marketing purposes, and to receive marketing, advertising and promotional information, materials and/or documents about UTP’s products and/or services, or such products and/or services by UTP’s business or strategic partners, and any related promotions, programmes, events, or contests organized by UTP. 
              </label>
            </div>

            <div className="w-100 px-md-2">
              <Button
                type="submit"
                className="submit-btn"
                variant="default"
                disabled={hasEmptyField || loading}
                onClick={handleSubmit}
              >
                <div>{loading ? 'Loading...' : 'SUBMIT'}</div>
              </Button>
            </div>
          </Row>
        </Col>
      </Row>
      <div className="mobile-show">
        {/* <img width="40%" src={logo} alt="event-logo" className="d-block mx-auto" /> */}
      </div>
    </Page>
  )
}
